'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopUpFlowModalContainer = exports.mapDispatchToProps = exports.mapStateToProps = exports.modalConfig = undefined;

var _reactRedux = require('react-redux');

var _bound = require('redux/saga/entities/bound');

var _selectors = require('redux/saga/selectors');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Reservation = require('../Reservation.saga');

var _TopUpFlow = require('./TopUpFlow');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modalConfig = exports.modalConfig = {};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var reservation = _bound.createReservation.select(state) || {};
  var creditsBalance = _bound.userCreditBalance.data(state, (0, _selectors.scheduleContext)(state)).credits_remaining;
  var user = _bound.userProfile.data(state) || {};

  var _ownProps$schedule = ownProps.schedule,
      _ownProps$schedule$av = _ownProps$schedule.availability,
      credits = _ownProps$schedule$av.credits,
      _ownProps$schedule$av2 = _ownProps$schedule$av.top_up.purchase,
      cost = _ownProps$schedule$av2.amount,
      creditsNeeded = _ownProps$schedule$av2.credits,
      currencyCode = _ownProps$schedule$av2.currency,
      includeTax = _ownProps$schedule$av2.taxable,
      _ownProps$schedule$cl = _ownProps$schedule.class,
      description = _ownProps$schedule$cl.description,
      klassName = _ownProps$schedule$cl.name,
      cancellationPolicy = _ownProps$schedule.cancellation_policy,
      endTime = _ownProps$schedule.endtime,
      scheduleId = _ownProps$schedule.id,
      source = _ownProps$schedule.source,
      startTime = _ownProps$schedule.starttime,
      _ownProps$schedule$ve = _ownProps$schedule.venue,
      address = _ownProps$schedule$ve.address,
      venueId = _ownProps$schedule$ve.id,
      imageUrl = _ownProps$schedule$ve.images.default,
      lateCancellation = _ownProps$schedule$ve.late_cancellation,
      locationName = _ownProps$schedule$ve.location.name,
      venueName = _ownProps$schedule$ve.name,
      timeZone = _ownProps$schedule$ve.tz;


  return {
    loading: reservation.loading,
    loaded: reservation.loaded,
    error: reservation.error,

    endOfCycleDate: user.membership && user.membership.cycle_end,
    msaTimeZone: user.msa && user.msa.timezone,

    address: address,
    cancellationPolicy: cancellationPolicy,
    cost: cost,
    credits: credits,
    creditsNeeded: creditsNeeded,
    creditsBalance: creditsBalance,
    currencyCode: currencyCode,
    description: description,
    endTime: endTime,
    includeTax: includeTax,
    klassName: klassName,
    locationName: locationName,
    lateCancellation: lateCancellation,
    scheduleId: scheduleId,
    source: source,
    startTime: startTime,
    imageUrl: imageUrl,
    timeZone: timeZone,
    venueName: venueName,
    venueId: venueId
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  onReservationRequest: _Reservation.requestReservation,
  onModalOpen: _bound.createReservation.resetAction
};

var TopUpFlowModalContainer = exports.TopUpFlowModalContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _Modal2.default)(modalConfig)(_TopUpFlow.TopUpFlow));